module.exports = __webpack_public_path__ + "img/en.c2c3cadc.svg";